import React from 'react';

const GenderRadio = ({
  id,
  name,
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  errors = {}
}) => {
  const genderOptions = [
    { value: 'Masculin', label: 'Homme', icon: '👨' },
    { value: 'Feminin', label: 'Femme', icon: '👩' },
    { value: 'Autre', label: 'Autre', icon: '👤' }
  ];

  const handleChange = (selectedValue) => {
    const event = {
      target: {
        name: name,
        value: selectedValue
      }
    };
    onChange(event);
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-gray-700">
        {label} {required && <span className="text-orange-500">*</span>}
      </label>

      <div className="flex flex-wrap gap-4">
        {genderOptions.map((option) => (
          <label
            key={option.value}
            className={`flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 hover:border-blue-300 hover:bg-blue-50 ${
              value === option.value
                ? 'border-blue-500 bg-blue-50 shadow-md'
                : errors[name]
                  ? 'border-orange-300 bg-orange-50'
                  : disabled
                    ? 'border-gray-200 bg-gray-50 cursor-not-allowed'
                    : 'border-gray-200 bg-white'
            }`}
          >
            <input
              type="radio"
              id={`${id}_${option.value}`}
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => handleChange(option.value)}
              disabled={disabled}
              className="sr-only" // Masquer le radio button natif
            />

            <div className="flex items-center space-x-3">
              <span className="text-2xl">{option.icon}</span>
              <span className={`font-medium ${
                value === option.value
                  ? 'text-blue-700'
                  : disabled
                    ? 'text-gray-400'
                    : 'text-gray-700'
              }`}>
                {option.label}
              </span>
            </div>

            {/* Indicateur de sélection */}
            {value === option.value && (
              <div className="ml-auto">
                <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            )}
          </label>
        ))}
      </div>

      {errors[name] && (
        <p className="mt-1 text-sm text-orange-600">{errors[name]}</p>
      )}
    </div>
  );
};

export default GenderRadio;